export var InvoiceStatus = {
  NonePaid: 1,
  SomePaid: 2,
  PaidInFull: 3,
  Cancelled: 7
};
export var PENDO_API_KEY = "91cb0fdd-a09c-4c90-739a-423fd94f8b93";